import React from 'react';
import cn from 'classnames';
import {StandardProps} from '..';

export type DialogTitleProps = StandardProps;

export const DialogTitle: React.FC<DialogTitleProps> = ({children, className, ...restProps}) => {
  return (
    <div
      className={cn(
        'dialog__title',
        'pt-5 px-5 pb-5 pt-sm-7 px-sm-6 pb-sm-6',
        'h6-medium sm:h3-medium border-bottom',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default DialogTitle;
